import type { FormattedFeedProductType } from '@/types'

import getProductKey from './getProductKey'

type CartPresence = Record<string, number>

const flattenOffers = (products: FormattedFeedProductType[]) =>
  products.flatMap((product) => [product, ...(product.children ?? [])])

export const mergeCartPresence = (
  current: CartPresence,
  products: FormattedFeedProductType[]
): CartPresence =>
  flattenOffers(products).reduce<CartPresence>(
    (presence, offer) => {
      if (offer.suppliersStock.length === 0) return presence
      const key = String(getProductKey(offer))
      const quantity = offer.suppliersStock[0]?.stock[0]?.cartInfo?.quantity
      if (quantity !== undefined && quantity > 0) {
        return { ...presence, [key]: quantity }
      }
      const { [key]: _removed, ...rest } = presence
      return rest
    },
    { ...current }
  )
